/* eslint-disable @typescript-eslint/no-empty-function */
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/Tooltip";
import { uniqBy } from "lodash";
import type { IGeographicalCountry } from "types/graphqlTypes";

interface IGeographicalCountryStackProps {
  geographicalCountries: IGeographicalCountry[];
  limit?: number;
  size?: number;
}

function GeographicalCountryStack({ geographicalCountries, limit = 6, size = 24 }: IGeographicalCountryStackProps) {
  const countries = uniqBy(geographicalCountries, (geographicalCountry) => {
    return geographicalCountry.isoCode;
  });
  if (countries.length === 0) {
    return null;
  }

  return (
    <div className="m-0 flex items-center -space-x-1">
      {countries.slice(0, limit).map((country) => {
        return (
          <TooltipProvider key={country.isoCode} delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild={true}>
                <img
                  title={country.name}
                  alt={country.name}
                  src={country.flagSvg.ovalHref}
                  width={size}
                  height={size}
                  className="squircle"
                />
              </TooltipTrigger>
              <TooltipContent
                side="top"
                sideOffset={12}
                className="max-w-xs rounded-xl border border-transparent bg-black text-white"
              >
                <strong className="font-bold">{country.name}</strong>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      })}
    </div>
  );
}

export default GeographicalCountryStack;
